<template>
  <div>
    <a-card v-if="pageLoading">
      <a-spin tip="Loading..." :spinning="pageLoading"
      ></a-spin> 
    </a-card>
    <!-- <a-modal
      v-model="visibleModalTree" @ok="modalbuttonAdd" :footer="null"
      title="Detil Anggaran"
    >
      <a-form :form="formtree">
        <a-form-item label="Peruntukan">
          <a-select
            showSearch
            allowClear
            option-filter-prop="children"
            :filter-option="filterOptionperuntukan"
            @change="handleperuntukan"
            v-decorator="['peruntukan', {rules: [{required: true}], initialValue: initialData.modal.peruntukan}]"
          >
            <a-select-option
              v-for="item in tree"
              :key="item.key"
            >{{item.title}}</a-select-option> 
          </a-select>
        </a-form-item>
        <a-form-item label="Sub Peruntukan">
          <a-auto-complete
            class="certain-category-search"
            dropdownClassName="certain-category-search-dropdown"
            :dropdownMatchSelectWidth="false"
            optionLabelProp="value"
            v-decorator="['subperuntukan', {rules: [{required: true}], initialValue: initialData.modal.subperuntukan}]"
          >
            <template slot="dataSource">
              <a-select-option v-for="item in initialData.subtree" :key="item.key" :value="item.title" >{{item.title}}</a-select-option>
            </template>
            <a-input>
              <a-icon slot="suffix" type="down" class="certain-category-icon" />
            </a-input>
          </a-auto-complete>
        </a-form-item>
        <a-form-item label="Item Anggaran">
          <a-input
            maxlength="15"
            v-decorator="['itemAnggaran', {rules: [{required: true}], initialValue: initialData.modal.itemAnggaran}]"
          ></a-input>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button @click="modalbuttonAdd" block type="primary" html-type="submit">Tambah</a-button>
        </a-form-item>
      </a-form>
    </a-modal> -->
    <div v-else>
    <TableAnggaran v-if="genColumn.length>0" :source="manifest.tree"
      :column="genColumn" :head="data" :listTahun="listThn" :allowtoEdit="true"/>
    </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import _ from "lodash";
import TableAnggaran from "@/components/TableSimulation.vue";
export default {
  name: "detilAnggaran",
  components: {
    TableAnggaran,
  },
  props: {
    submitdata: {},
    info: String,
    data: {},
    mode: String,
    id:String,
    dataEdit:{},
  },
  data() {
    return {
      editModal: false,
      pageLoading: true,
      manifest: [],
      satuan: [],
      push: [],
      dataList: [],
      pagination: {
        onChange: (page) => {},
        pageSize: 12,
        size: "small",
      },
      fileUpload: {
        name: "",
      },
      pushsts: false,
      //visibleModalTree: false,
      genColumn:[],
      year: [{tahun : this.data.year}],
      listThn: {dtl :[],rekap:[],hutang_tahun_berikutnya:[],validatorUtang:[]},
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formtree = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    initialData() {
      let data = {};
      if (this.data === undefined || this.data.length <= 0) {
        data = {
          // nomor_kontrak: "",
          // judul_kontrak: "",
          // tanggal_kontrak: moment(),
          // jenis: this.info,
        };
      } else {
        if (this.mode === "Create") {
          data = {
            // nomor_kontrak: this.data.kontrak.nomor_kontrak,
            // judul_kontrak: this.data.kontrak.judul_kontrak,
            // tanggal_kontrak: this.data.kontrak.tanggal_kontrak,
            // jenis: this.info,
          };
        } else if (this.mode === "Edit") {
          data = {
            // nomor_kontrak: this.data.nomor_kontrak,
            // judul_kontrak: this.data.judul,
            // tanggal_kontrak: this.data.tanggal_kontrak,
            // jenis: this.info,
          };
        }
      }

      data = {
        modal : {
          peruntukan: undefined,
          subperuntukan: undefined,
          itemAnggaran: undefined,
          keyforadd: undefined
        }
      }

      data.subtree = [];

      return data;
    },
    initialSatuan() {
      let satuan = [];
      this.satuan.forEach((item) => {
        satuan.push(item["satuan"]);
      });

      return satuan;
    },
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const kolom = [
            {
              title: "No",
              dataIndex: "no",
              key: "no",
              width: 10,
              sorter: (a, b) => a.no.length - b.no.length,
            },
            {
              title: "Bulan",
              dataIndex: "bulan",
              width: 50,
              key: "bulan",
              sorter: (a, b) =>
                new Date(
                  moment(a.bulan, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ) -
                new Date(
                  moment(b.bulan, this.getDefaultDateFormat).format(
                    this.getStandartFormatDate
                  )
                ),
            },
            {
              title: "Nilai",
              dataIndex: "nilai",
              key: "nilai",
              width: 75,
              sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
            },
          ];
      return kolom;
    },
  },
  created() {
    this.fetchingSatuan();
    this.fetchManifest();
  },
  mounted() {
    //this.fetchTree();
    // if (this.mode === "Edit") {
    //   const dataListeVal = this.data.detil_kontrak
    //     ? this.data.detil_kontrak
    //     : this.data.detail_list;

    //   let keyforEach = 0;
    //   dataListeVal.forEach((item) => {
    //     this.dataList = [
    //       ...this.dataList,
    //       {
    //         keyIndex: keyforEach,
    //         jumlah: item.jumlah,
    //         nama_produk: item.nama_produk,
    //         satuan: item.satuan,
    //       },
    //     ];
    //     keyforEach++;
    //   });
    //   if (this.data.dokumen !== "") {
    //     this.fileUpload.name = this.data.dokumen;
    //   } else {
    //     this.fileUpload.name = "";
    //   }
    // }
    // if (this.mode === "Create") {
    //   const dataListeVal = this.data
    //     ? this.data.detail_list && this.data.detail_list.length > 0
    //       ? this.data.detail_list
    //       : []
    //     : [];

    //   let keyforEach = 0;
    //   dataListeVal.forEach((item) => {
    //     this.dataList = [
    //       ...this.dataList,
    //       {
    //         keyIndex: keyforEach,
    //         jumlah: item.jumlah,
    //         nama_produk: item.nama_produk,
    //         satuan: item.satuan,
    //       },
    //     ];
    //     keyforEach++;
    //   });
    // }
    // if (this.data && this.data.pushsts === true) {
    //   this.pushsts = true;
    // }

    Event.$on("confirmMessageDelete", this.delete);
    Event.$on("confirmMessageDeleteDetil", this.deleteDetil);
    Event.$on("editCell", this.saveEditing);
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.delete);
    Event.$off("confirmMessageDeleteDetil", this.deleteDetil);
    Event.$off("editCell", this.saveEditing);
  },
  methods: {
    moment,
    handleSatuan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    fetchManifest() {
      console.log("fetchManifest")
      if (this.mode=="Edit"){
            if (this.submitdata!==undefined){
              this.manifest = this.submitdata;
              this.listThn.hutang_tahun_berikutnya = this.submitdata.hutang_tahun_berikutnya;
              this.generateColumn();
            }else{
              this.manifest = this.dataEdit;
              this.listThn.hutang_tahun_berikutnya = this.dataEdit.hutang_tahun_berikutnya;
              this.generateColumn();
              this.pageLoading = false;
            }
      }else{
        if ((this.submitdata!==undefined && this.submitdata.tahun[0]==this.data.year) &&
          (this.data && this.submitdata && this.data.template_simulation == this.submitdata.id_simulasi)){
          this.manifest = this.submitdata;
          this.listThn.hutang_tahun_berikutnya = this.submitdata.hutang_tahun_berikutnya;
          this.generateColumn();
        }else{
          let param = {}
          if (this.data.template_simulation){
            param = {
              tahun : this.data.year,
              id_simulasi : this.data.template_simulation ? this.data.template_simulation : this.id,
              jenis: "edit",
              duplicate: "true"
            }
          }else{
            param = {
              tahun : this.data.year,
              id_simulasi : this.data.template_simulation ? this.data.template_simulation : this.id,
              jenis: "edit"
            }
          }

          axios({
            method: "get",
            url: this.$serviceUrl + (this.mode=="Edit" ? "simulasi/manifest" : this.data.template_simulation ? "simulasi/manifest" : "simulasi"),
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
            params:param
          })
            .then((response) => {
              this.manifest = response.data;
              this.listThn.hutang_tahun_berikutnya = response.data.hutang_tahun_berikutnya;
              this.generateColumn();
              this.pageLoading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    generateColumn(){
      let rangethn = [];
      let lop = 0;
      var gencolm = [];

      //colom title item / cost center
      gencolm = [{
          slots: { title: 'customTitleMain'},
          key: 'name',
          width: 310,
          fixed: "left",
          showcolumn:"",
          scopedSlots: { customRender: "name" }
        }];
      //colom header all tahun
      gencolm.push({
          key: 'alltahun',
          slots: { title: 'customTitleAllTahun' },
          scopedSlots: { customRender: 'alltahun' },
          dataIndex: 'rangetahun',
          align: "left",
          width:150,
          children: []
        }
      );
      this.year.forEach((item) => {
        rangethn[lop]=item["tahun"];

        //detil
        var dtljson = {
          slots: { title: 'customTitleThn'},
          scopedSlots: { customRender: 'tahun' },
          className: "unhide header th"+item["tahun"],
          width:150,
          children: [
            {
              title: 'Jan',
              width: 150,
              dataIndex: 'bln'+item["tahun"]+'1',
              key: 'bln'+item["tahun"]+'1',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: ('dtlitem01') }
            },
            {
              title: 'Feb',
              width:150,
              dataIndex: 'bln'+item["tahun"]+'2',
              key: 'bln'+item["tahun"]+'2',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: 'dtlitem02' }
            },
            {
              title: 'Mar',
              width:150,
              dataIndex: 'bln'+item["tahun"]+'3',
              key: 'bln'+item["tahun"]+'3',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: 'dtlitem03' }
            },
            {
              title: 'Apr',
              width:150,
              dataIndex: 'bln'+item["tahun"]+'4',
              key: 'bln'+item["tahun"]+'4',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: 'dtlitem04' }
            },
            {
              title: 'May',
              width:150,
              dataIndex: 'bln'+item["tahun"]+'5',
              key: 'bln'+item["tahun"]+'5',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: 'dtlitem05' }
            },
            {
              title: 'Jun',
              width:150,
              dataIndex: 'bln'+item["tahun"]+'6',
              key: 'bln'+item["tahun"]+'6',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: 'dtlitem06' }
            },
            {
              title: 'Jul',
              width:150,
              dataIndex: 'bln'+item["tahun"]+'7',
              key: 'bln'+item["tahun"]+'7',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: 'dtlitem07' }
            },
            {
              title: 'Aug',
              width:150,
              dataIndex: 'bln'+item["tahun"]+'8',
              key: 'bln'+item["tahun"]+'8',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: 'dtlitem08' }
            },
            {
              title: 'Sep',
              width:150,
              dataIndex: 'bln'+item["tahun"]+'9',
              key: 'bln'+item["tahun"]+'9',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: 'dtlitem09' }
            },
            {
              title: 'Okt',
              width:150,
              dataIndex: 'bln'+item["tahun"]+'10',
              key: 'bln'+item["tahun"]+'10',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: 'dtlitem10' }
            },
            {
              title: 'Nov',
              width:150,
              dataIndex: 'bln'+item["tahun"]+'11',
              key: 'bln'+item["tahun"]+'11',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: 'dtlitem11' }
            },
            {
              title: 'Des',
              width:150,
              dataIndex: 'bln'+item["tahun"]+'12',
              key: 'bln'+item["tahun"]+'12',
              align: 'right',
              className: "unhide th"+item["tahun"],
              scopedSlots: { customRender: 'dtlitem12' }
            },
          ],
        };

        //rekap
        var dtljson2 = {
          title: "",
          className: "hide header th"+item["tahun"]+"rekap kolom",
          width:150,
          children: [
            {
              title: 'Sub Total',
              dataIndex: 'rekap'+item["tahun"],
              key: 'rekap'+item["tahun"],
              align: 'right',
              width: 150,
              float:"right",
              className: "hide th"+item["tahun"]+"rekap kolom",
              scopedSlots: { customRender: 'dtlitemrekap' }
            },
          ]}
        ;


        //push ke variable generate top root
        gencolm[1].children.push(dtljson);
        gencolm[1].children.push(dtljson2);
        lop++
      });

      //rekap allrange tahun
      var rkpjson = {
          slots: { title: 'customTitleTahun' },
          scopedSlots: { customRender: 'tahun' },
          className: "hide alltahun",
          children: [
            // {
            //   title: 'Grand Total',
            //   dataIndex: 'rekapalltahun',
            //   key: 'rekapalltahun',
            //   align: 'right',
            //   float: "left",
            //   width: 300,
            //   className: "hide alltahun",
            //   scopedSlots: { customRender: 'dtlitemrekap' }
            // },
          ],
        };
      gencolm[1].children.push(rkpjson);

      // var rkpjson3 = {
      //     title: '' ,
      //     className: "relative",
      //     children: [
      //       {
      //         title: '',
      //         dataIndex: '',
      //         key: 'relative',
      //         align: 'right',
      //         float: "left",
      //         className: "relative",
      //       },
      //     ],
      //   };
      // gencolm[1].children.push(rkpjson3);

      this.listThn.dtl=rangethn;
      this.listThn.rekap=rangethn;
      this.genColumn = gencolm;
    },
    fetchingSatuan() {
      axios({
        method: "get",
        url: this.$serviceUrl + "project/produk_satuan",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.satuan = response.data.data;
          this.pageLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleRemoveDetail(item) {
      this.confirmMessageValue("confirm-delete-detil", item);
    },
    deleteDetil(item) {
      const index = this.dataList.indexOf(item);
      const newFileList = this.dataList.slice();
      newFileList.splice(index, 1);
      this.dataList = newFileList;
    },
    handleRemove() {
      if (this.mode === "Edit") {
        if (this.data.dokumen !== "") {
          this.confirmMessageValue("confirm-delete", undefined);
        } else {
          this.push = [];
          this.fileUpload.name = "";
        }
      } else {
        this.push = [];
        this.fileUpload.name = "";
      }
    },
    delete() {
      if (this.pushsts === true) {
        this.push = [];
        this.fileUpload.name = "";
        this.data.dokumen = "";
      } else {
        const serviceUrl = this.$serviceUrl;
        const name = this.data.dokumen;
        const auth = {
          username: this.getAuth.username,
          password: this.getAuth.password,
          apikey: this.getAuth.apikey,
        };
        axios({
          method: "delete",
          url: serviceUrl + "project/file_dokumen",
          processData: false,
          data: {
            file_dokumen: name,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            Event.$emit("refresh", true);
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.mode === "Edit") {
          if (this.data.dokumen !== "") {
            this.displayMessage("form-duplicate-contract");
          }
        }

        let slice = [...this.push, file];
        this.fileUpload.name = file.name;
        slice = slice.slice(-1);
        this.push = slice;
        this.pushsts = true;
        return false;
      }
    },
    handleRef() {
      this.manifest.nama_simulasi = this.data.simulation_nm;
      this.manifest.catatan = this.data.note ? this.data.note : "";
      this.manifest.tlc = this.getAuth.username;
      this.manifest.hutang_tahun_berikutnya = this.listThn.hutang_tahun_berikutnya;
      this.manifest.validatorUtang = this.listThn.validatorUtang
      Event.$emit("headerform", {
        submitValue: this.manifest
      });
    },
    handleRefBack() {
      let kontrak = this.form.getFieldsValue();
      kontrak.tanggal_kontrak = moment(kontrak.tanggal_kontrak).format(
        this.getStandartFormatDate
      );
      Event.$emit("projectrabBack", {
        file_upload: this.push,
        kontrak: JSON.parse(JSON.stringify(kontrak)),
        detail_list: this.dataList,
        nomor_kontrak: kontrak.nomor_kontrak,
        judul: kontrak.judul_kontrak,
        tanggal_kontrak: kontrak.tanggal_kontrak,
        jenis: this.info,
        dokumen: this.fileUpload.name,
        pushsts: this.pushsts,
      });
    },
    // handleEditModal() {
    //   this.visibleModalTree = !this.visibleModalTree;
    // },
    filterOptionProduk(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleDetail(val) {
    },
    // fetchTree() {
    //     const serviceUrl = this.$serviceUrl;
    //     const auth = {
    //       username: this.getAuth.username,
    //       password: this.getAuth.password,
    //       apikey: this.getAuth.apikey,
    //     };
    //     axios({
    //       method: "get",
    //       url: serviceUrl + "anggaran/template_anggaran",
    //       processData: false,
    //       params: {
    //         jns_anggaran_id: "01",
    //       },
    //       auth: {
    //         username: auth.username,
    //         password: auth.password,
    //       },
    //       headers: {
    //         "X-API-KEY": auth.apikey,
    //       },
    //     })
    //       .then((response) => {
    //         //console.log(response.data.tree);
    //           this.tree = response.data.tree;
    //       })
    //       .catch((err) => {
    //         console.log("error : " + err);
    //       });
    // },
    filterOptionperuntukan(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOptionsubperuntukan(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleperuntukan(valu){
      console.log(valu);
      let filter = _.filter(
        this.tree,
        obj =>
          obj.key &&
          obj.key
            .toLowerCase()
            .indexOf(valu.toLowerCase()) >= 0
      );
      this.initialData.subtree = filter[0].children;
      this.initialData.keyforadd = filter[0].children.length+1;
    },
    modalbuttonAdd(){
      this.formtree.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }
          //console.log(values);

          for (let i = 0; i < this.tree.length; i++) {
            if (this.tree[i].key === values.peruntukan){
              let ObjectItem = {
                children: {},
                is_parent: "true",
                isedit:"1",
                key: values.peruntukan+(this.tree[i].children.length+1),
                kode_sub_peruntukan: this.tree[i].children.length+1,
                scopedSlots :{
                  icon: "notyet",
                  type: "SPRT"
                },
                status: "true",
                title: values.itemAnggaran
              }
              let akh = this.tree[i].children.length;
              console.log(akh);
              this.tree[i].children[akh]=ObjectItem;
              console.log(this.tree);
            }
          }
      });
    },
    saveEditing(item){
      console.log("sippp");
      console.log(item);
    }
  },
};
</script>

<style lang="less" scoped>
.hide{display:none}
</style>